import React, {useEffect, useState, useCallback} from 'react';
import {useLocation} from 'react-router-dom';
import {BillingMessage} from 'containers/Main/Settings/Billing/styles';
import {SEAT_PRICING_INELIGIBILITY} from 'data/queryParams';
import {Body, ContactSupportLink, Header} from "components/SeatsIneligibilityAlert/styles";
import {Links} from "data/links";
import { ReactComponent as WarningIcon } from 'assets/images/icons/alert-triangle-orange.svg';
import {useMe} from "../../data/hooks/useMe";
import {isGmailAddress} from "../../utils/userUtils";

const STORAGE_KEY = `key-${SEAT_PRICING_INELIGIBILITY}`;
const SESSION_TRUE = 'true';
const SESSION_FALSE = 'false';

export type SeatsIneligibilityAlertProps = {
  domain?: string;
}

export const SeatsIneligibilityAlert = ({domain}: SeatsIneligibilityAlertProps) => {
  const {search} = useLocation();
  const {me} = useMe();

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (new URLSearchParams(search).has(SEAT_PRICING_INELIGIBILITY)) {
      sessionStorage.setItem(STORAGE_KEY, SESSION_TRUE);
    }
    setIsVisible(sessionStorage.getItem(STORAGE_KEY) === SESSION_TRUE);
  }, [search]);

  const hide = useCallback(() => {
    sessionStorage.setItem(STORAGE_KEY, SESSION_FALSE);
    setIsVisible(false);
  }, []);

  if (!isVisible || !domain || isGmailAddress(me?.email)) {
    return null;
  }
  return (
    <BillingMessage
      variant="WARNING"
      isOpen
      onClose={hide}
      title=""
      icon={<WarningIcon />}
      message={
        <>
          <Header>Your domain {domain} is not yet eligible for seat-based pricing</Header>
          <Body><ContactSupportLink href={Links.CONTACT_US} target="_blank">Contact
            support</ContactSupportLink> if you’d like early access.</Body>
        </>
      }
      id={SEAT_PRICING_INELIGIBILITY}
    />
  );
};
